import { CheckBox, MultiSelect } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import { useFiltro } from '../../../../../../../../contexts/FilaEmbarque/Filtro/hooks/useFiltro';
import TipoDirecionamentoEnum from '../../../../../../Enum/TipoDirecionamentoEnum';
import { CheckBoxesConteiner, Container } from './styles';

export function TipoLote({
  dispatchTransportadorasETipoLote,
  transportadoras,
}) {
  const { filtro } = useFiltro();
  const { tipoLote } = filtro.filtrosDrawer;
  const [transportadorasOptions, setTransportadorasOptions] = useState(
    transportadoras.map(transportadora => ({
      id: transportadora.id,
      idTransportadora: transportadora.idTransportadora,
      label: transportadora.razao,
      checked: false,
    }))
  );

  const [tipoLoteController, setTipoLoteController] = useState({
    marketplace: false,
    transportadora: false,
  });

  const transportadorasSelecionadas = useMemo(
    () => transportadorasOptions.filter(option => option.checked),
    [transportadorasOptions]
  );

  const getLabel = () =>
    transportadorasSelecionadas.length > 0
      ? `${transportadorasSelecionadas.length} ${
          transportadorasSelecionadas.length === 1
            ? 'Selecionado'
            : 'Selecionados'
        }`
      : 'Todos';

  const handleSelectTransportadoras = options => {
    setTransportadorasOptions(options);
    const ids = [...new Set(options.map(option => option.idTransportadora))];
    dispatchTransportadorasETipoLote({ idTransportadora: ids });
  };

  const handleOnChange = (checked, name, value) => {
    setTipoLoteController(prevState => ({
      ...prevState,
      [name]: checked,
    }));

    dispatchTransportadorasETipoLote({
      tipoLote: checked
        ? [...tipoLote, value]
        : tipoLote.filter(item => item !== value),
    });
  };

  useEffect(() => {
    setTipoLoteController({
      marketplace: tipoLote.includes(TipoDirecionamentoEnum.MARKETPLACE),
      transportadora: tipoLote.includes(TipoDirecionamentoEnum.TRANSPORTADORA),
    });

    if (Object.keys(tipoLote).length === 0) {
      setTransportadorasOptions(prevState =>
        prevState.map(option => ({
          ...option,
          checked: false,
        }))
      );
    }
  }, [tipoLote]);

  return (
    <Container>
      <CheckBoxesConteiner>
        <CheckBox
          label={
            TipoDirecionamentoEnum.getTipo(TipoDirecionamentoEnum.MARKETPLACE)
              .label
          }
          checked={tipoLoteController.marketplace}
          updateChecked={checked =>
            handleOnChange(
              checked,
              'marketplace',
              TipoDirecionamentoEnum.MARKETPLACE
            )
          }
        />
        <CheckBox
          label={
            TipoDirecionamentoEnum.getTipo(
              TipoDirecionamentoEnum.TRANSPORTADORA
            ).label
          }
          checked={tipoLoteController.transportadora}
          updateChecked={checked =>
            handleOnChange(
              checked,
              'transportadora',
              TipoDirecionamentoEnum.TRANSPORTADORA
            )
          }
        />
      </CheckBoxesConteiner>
      <MultiSelect
        label={getLabel()}
        options={transportadorasOptions}
        onChange={handleSelectTransportadoras}
        style={{
          display: `${tipoLoteController.transportadora ? 'block' : 'none'}`,
        }}
      />
    </Container>
  );
}

TipoLote.propTypes = {
  dispatchTransportadorasETipoLote: PropTypes.func.isRequired,
  transportadoras: PropTypes.arrayOf(PropTypes.object).isRequired,
};
